import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { DiaryEvent } from './diary_events';

@Injectable({ providedIn: 'root' })
export class DiaryEventProvider extends DomainEventProvider<DiaryEvent> {}
